var _circle, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9265 5.86768C19.1445 5.86768 20.1189 6.74269 20.1189 7.83673C20.1189 8.92983 19.1443 9.80457 17.9265 9.80457C16.7277 9.80457 15.7344 8.92983 15.7344 7.83673C15.7344 6.74269 16.7277 5.86768 17.9265 5.86768Z",
    fill: "#ADAAE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7512 19.7319C15.9586 23.8369 14.3117 25.4522 11.3316 27C14.048 24.442 15.6955 21.9514 15.8476 19.3784L15.9415 18.6028C15.8849 15.5089 14.797 12.6815 12.9425 10.2421L11.987 9.09867C10.151 7.07973 7.75374 5.34605 5 4C10.3952 5.29671 16.3722 8.72782 18.4887 13.5899C20.511 11.1173 21.1675 8.15538 21.13 5.14474C22.1607 8.07169 22.2548 10.8993 21.5224 13.5238C21.4484 13.91 21.3176 14.3488 21.1496 14.8682C20.718 16.2152 20.0814 17.5453 19.3139 18.8065L18.7512 19.7319Z",
    fill: "#ADAAE3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoya);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTUiIGN5PSIxNSIgcj0iMTUiIGZpbGw9Im5vbmUiLz4KPHBhdGggZD0iTTE3LjkyNjUgNS44Njc2OEMxOS4xNDQ1IDUuODY3NjggMjAuMTE4OSA2Ljc0MjY5IDIwLjExODkgNy44MzY3M0MyMC4xMTg5IDguOTI5ODMgMTkuMTQ0MyA5LjgwNDU3IDE3LjkyNjUgOS44MDQ1N0MxNi43Mjc3IDkuODA0NTcgMTUuNzM0NCA4LjkyOTgzIDE1LjczNDQgNy44MzY3M0MxNS43MzQ0IDYuNzQyNjkgMTYuNzI3NyA1Ljg2NzY4IDE3LjkyNjUgNS44Njc2OFoiIGZpbGw9IiNBREFBRTMiLz4KPHBhdGggZD0iTTE4Ljc1MTIgMTkuNzMxOUMxNS45NTg2IDIzLjgzNjkgMTQuMzExNyAyNS40NTIyIDExLjMzMTYgMjdDMTQuMDQ4IDI0LjQ0MiAxNS42OTU1IDIxLjk1MTQgMTUuODQ3NiAxOS4zNzg0TDE1Ljk0MTUgMTguNjAyOEMxNS44ODQ5IDE1LjUwODkgMTQuNzk3IDEyLjY4MTUgMTIuOTQyNSAxMC4yNDIxTDExLjk4NyA5LjA5ODY3QzEwLjE1MSA3LjA3OTczIDcuNzUzNzQgNS4zNDYwNSA1IDRDMTAuMzk1MiA1LjI5NjcxIDE2LjM3MjIgOC43Mjc4MiAxOC40ODg3IDEzLjU4OTlDMjAuNTExIDExLjExNzMgMjEuMTY3NSA4LjE1NTM4IDIxLjEzIDUuMTQ0NzRDMjIuMTYwNyA4LjA3MTY5IDIyLjI1NDggMTAuODk5MyAyMS41MjI0IDEzLjUyMzhDMjEuNDQ4NCAxMy45MSAyMS4zMTc2IDE0LjM0ODggMjEuMTQ5NiAxNC44NjgyQzIwLjcxOCAxNi4yMTUyIDIwLjA4MTQgMTcuNTQ1MyAxOS4zMTM5IDE4LjgwNjVMMTguNzUxMiAxOS43MzE5WiIgZmlsbD0iI0FEQUFFMyIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };